var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("matrix-option", { attrs: { "active-data": _vm.activeData } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }